(function () {
  'use strict';

  function initMobileStickyBuyBar() {

    const stickyBar = document.querySelector(
      '[data-mobile-sticky-buy-bar]'
    );

    if (!stickyBar) {
      return;
    }

    /*
     * ---------------------------------------------------------
     * FIND REAL SHOPIFY PRODUCT FORM
     * ---------------------------------------------------------
     */

    function getProductForm() {

      let form = document.querySelector(
        'product-form form[data-type="add-to-cart-form"]'
      );

      if (form) {
        return form;
      }

      form = document.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

      return form || null;
    }

    /*
     * ---------------------------------------------------------
     * GET VARIANT
     * ---------------------------------------------------------
     */

    function getVariantId(form) {

      if (!form) {
        return null;
      }

      const variantInput = form.querySelector(
        'input[name="id"]'
      );

      if (!variantInput) {
        return null;
      }

      return variantInput.value;
    }

    /*
     * ---------------------------------------------------------
     * GET REAL QUANTITY INPUT
     * ---------------------------------------------------------
     */

    function getNativeQuantityInput(form) {

      if (!form) {
        return null;
      }

      return form.querySelector(
        'input[name="quantity"]'
      );
    }

    /*
     * ---------------------------------------------------------
     * STICKY ELEMENTS
     * ---------------------------------------------------------
     */

    const stickyQuantityInput = stickyBar.querySelector(
      '[data-sticky-qty-input]'
    );

    const minusButton = stickyBar.querySelector(
      '[data-sticky-qty-minus]'
    );

    const plusButton = stickyBar.querySelector(
      '[data-sticky-qty-plus]'
    );

    const addButton = stickyBar.querySelector(
      '[data-sticky-add-to-cart]'
    );

    const buyButton = stickyBar.querySelector(
      '[data-sticky-buy-now]'
    );

    if (!stickyQuantityInput) {
      return;
    }

    /*
     * ---------------------------------------------------------
     * SET QUANTITY
     * ---------------------------------------------------------
     */

    function setQuantity(value) {

      value = parseInt(value, 10);

      if (isNaN(value) || value < 1) {
        value = 1;
      }

      const form = getProductForm();

      const nativeQuantity =
        getNativeQuantityInput(form);

      stickyQuantityInput.value = value;

      if (nativeQuantity) {

        nativeQuantity.value = value;

        nativeQuantity.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        nativeQuantity.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );

      }

      if (minusButton) {
        minusButton.disabled = value <= 1;
      }
    }

    /*
     * ---------------------------------------------------------
     * GET QUANTITY
     * ---------------------------------------------------------
     */

    function getQuantity() {

      let value = parseInt(
        stickyQuantityInput.value,
        10
      );

      if (isNaN(value) || value < 1) {
        value = 1;
      }

      return value;
    }

    /*
     * ---------------------------------------------------------
     * MINUS
     * ---------------------------------------------------------
     */

    if (minusButton) {

      minusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          const current = getQuantity();

          if (current > 1) {
            setQuantity(current - 1);
          }

        }
      );

    }

    /*
     * ---------------------------------------------------------
     * PLUS
     * ---------------------------------------------------------
     */

    if (plusButton) {

      plusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          const current = getQuantity();

          setQuantity(current + 1);

        }
      );

    }

    /*
     * ---------------------------------------------------------
     * MANUAL QUANTITY
     * ---------------------------------------------------------
     */

    stickyQuantityInput.addEventListener(
      'input',
      function () {

        let value = parseInt(
          stickyQuantityInput.value,
          10
        );

        if (isNaN(value) || value < 1) {
          value = 1;
        }

        stickyQuantityInput.value = value;

        if (minusButton) {
          minusButton.disabled = value <= 1;
        }

      }
    );

    stickyQuantityInput.addEventListener(
      'change',
      function () {

        setQuantity(
          stickyQuantityInput.value
        );

      }
    );

    /*
     * ---------------------------------------------------------
     * SYNC FROM NORMAL PRODUCT FORM
     * ---------------------------------------------------------
     */

    function syncFromNativeQuantity() {

      const form = getProductForm();

      const nativeQuantity =
        getNativeQuantityInput(form);

      if (!nativeQuantity) {
        return;
      }

      const value = parseInt(
        nativeQuantity.value,
        10
      );

      if (!isNaN(value) && value >= 1) {

        stickyQuantityInput.value = value;

        if (minusButton) {
          minusButton.disabled = value <= 1;
        }

      }

    }

    const initialForm = getProductForm();

    const initialNativeQuantity =
      getNativeQuantityInput(initialForm);

    if (initialNativeQuantity) {

      syncFromNativeQuantity();

      initialNativeQuantity.addEventListener(
        'input',
        syncFromNativeQuantity
      );

      initialNativeQuantity.addEventListener(
        'change',
        syncFromNativeQuantity
      );

    }

    /*
     * ---------------------------------------------------------
     * ADD TO CART
     * ---------------------------------------------------------
     */

    if (addButton) {

      addButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          const form = getProductForm();

          if (!form) {

            console.error(
              'Sticky Add to Cart: Product form not found.'
            );

            return;
          }

          const variantId =
            getVariantId(form);

          if (!variantId) {

            console.error(
              'Sticky Add to Cart: Variant not found.'
            );

            return;
          }

          const quantity = getQuantity();

          setQuantity(quantity);

          const nativeAddButton =
            form.querySelector(
              'button[name="add"]'
            );

          if (!nativeAddButton) {

            console.error(
              'Sticky Add to Cart: Native Add to Cart button not found.'
            );

            return;
          }

          if (nativeAddButton.disabled) {
            return;
          }

          addButton.disabled = true;

          const originalText =
            addButton.textContent;

          addButton.textContent =
            'ADDING...';

          if (
            typeof form.requestSubmit ===
            'function'
          ) {

            form.requestSubmit(
              nativeAddButton
            );

          } else {

            nativeAddButton.click();

          }

          setTimeout(
            function () {

              addButton.disabled =
                false;

              addButton.textContent =
                originalText;

            },
            1800
          );

        }
      );

    }

    /*
     * ---------------------------------------------------------
     * BUY NOW
     * ---------------------------------------------------------
     */

    if (buyButton) {

      buyButton.addEventListener(
        'click',
        async function (event) {

          event.preventDefault();

          const form = getProductForm();

          if (!form) {

            console.error(
              'Sticky Buy Now: Product form not found.'
            );

            return;
          }

          const variantId =
            getVariantId(form);

          if (!variantId) {

            console.error(
              'Sticky Buy Now: Variant not found.'
            );

            return;
          }

          const quantity = getQuantity();

          buyButton.disabled = true;

          const originalText =
            buyButton.textContent;

          buyButton.textContent =
            'PROCESSING...';

          try {

            const formData =
              new FormData(form);

            formData.set(
              'id',
              variantId
            );

            formData.set(
              'quantity',
              quantity
            );

            const root =
              window.Shopify &&
              window.Shopify.routes &&
              window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/';

            const response =
              await fetch(
                root + 'cart/add.js',
                {
                  method: 'POST',
                  headers: {
                    'Accept':
                      'application/json'
                  },
                  body: formData
                }
              );

            const data =
              await response.json();

            if (!response.ok) {

              throw new Error(
                data.description ||
                data.message ||
                'Unable to add product.'
              );

            }

            window.location.href =
              '/checkout';

          }
          catch (error) {

            console.error(
              'Sticky Buy Now Error:',
              error
            );

            buyButton.disabled =
              false;

            buyButton.textContent =
              originalText;

          }

        }
      );

    }

    /*
     * ---------------------------------------------------------
     * INITIAL QUANTITY
     * ---------------------------------------------------------
     */

    setQuantity(
      getQuantity()
    );

    /*
     * ---------------------------------------------------------
     * FIND NORMAL PRODUCT BUTTONS
     * ---------------------------------------------------------
     */

    const normalButtons =
      document.querySelector(
        '.product-form-buy-button .product-form__buttons'
      );

    /*
     * ---------------------------------------------------------
     * STICKY SHOW / HIDE
     * ---------------------------------------------------------
     */

    if (!normalButtons) {

      stickyBar.classList.add(
        'is-visible'
      );

      return;

    }

    if (
      typeof IntersectionObserver !==
      'undefined'
    ) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                if (entry.isIntersecting) {

                  stickyBar.classList.remove(
                    'is-visible'
                  );

                } else {

                  stickyBar.classList.add(
                    'is-visible'
                  );

                }

              }
            );

          },
          {
            threshold: 0.05
          }
        );

      observer.observe(
        normalButtons
      );

    } else {

      stickyBar.classList.add(
        'is-visible'
      );

    }

    /*
     * ---------------------------------------------------------
     * UPDATE AVAILABILITY
     * ---------------------------------------------------------
     */

    function updateAvailability() {

      const form =
        getProductForm();

      if (!form) {
        return;
      }

      const nativeButton =
        form.querySelector(
          'button[name="add"]'
        );

      const unavailable =
        nativeButton &&
        nativeButton.disabled;

      if (addButton) {
        addButton.disabled =
          !!unavailable;
      }

      if (buyButton) {
        buyButton.disabled =
          !!unavailable;
      }

    }

    updateAvailability();

    document.addEventListener(
      'change',
      function (event) {

        if (
          event.target.closest &&
          event.target.closest(
            'product-form'
          )
        ) {

          setTimeout(
            updateAvailability,
            50
          );

        }

      }
    );

  }

  /*
   * ---------------------------------------------------------
   * INITIALIZE
   * ---------------------------------------------------------
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMobileStickyBuyBar
    );

  } else {

    initMobileStickyBuyBar();

  }

})();